import {formatDate} from '../../Utils/formatDate';
import {TotemFatura as TotemFaturaType} from '../../services/TotemApi';

/**
 * Cartão de uma fatura na listagem do totem.
 * destaque: 'vencida' (vermelho), 'proxima' (amarelo, vencimento mais próximo) ou 'normal'.
 */

export type DestaqueFatura = 'vencida' | 'proxima' | 'normal' | 'paga';

interface TotemFaturaProps {
	fatura: TotemFaturaType;
	destaque: DestaqueFatura;
	carregando: string | null; // ação em andamento: 'pdf' | 'pix' | 'linha'
	onImprimir: (fatura: TotemFaturaType) => void;
	onPix: (fatura: TotemFaturaType) => void;
	onLinhaDigitavel: (fatura: TotemFaturaType) => void;
}

function formatarValor(valor: number) {
	return 'R$ ' + (valor || 0).toFixed(2).replace('.', ',');
}

export function TotemFatura({fatura, destaque, carregando, onImprimir, onPix, onLinhaDigitavel}: TotemFaturaProps) {
	const temBoleto = fatura.boleto === 1 && fatura.cobranca_entrada_confirmada === 1;
	const processando = fatura.id_status === 30;
	const temPix = temBoleto && fatura.id_cobranca_registro_lancamento !== null && fatura.id_cobranca_registro_lancamento !== false;

	let rotulo = '';
	if (destaque === 'vencida') rotulo = 'VENCIDA';
	if (destaque === 'proxima') rotulo = 'PRÓXIMO VENCIMENTO';
	if (destaque === 'paga') rotulo = 'PAGA';

	return (
		<div className={`totem-fatura totem-fatura-${destaque}`}>
			<div className="totem-fatura-info">
				{rotulo && <span className="totem-fatura-rotulo">{rotulo}</span>}
				<div className="totem-fatura-vencimento">Vencimento {formatDate(fatura.data_vencimento)}</div>
				<div className="totem-fatura-plano">{fatura.plano || ''}</div>
				<div className="totem-fatura-documento">{fatura.numero_documento}</div>
				<div className="totem-fatura-valor">{formatarValor(fatura.valor_total)}</div>
			</div>
			{destaque !== 'paga' && (
				<div className="totem-fatura-acoes">
					{processando && <span className="totem-fatura-aviso"><span className="material-icons" aria-hidden="true">schedule</span>Processando pagamento</span>}
					{!processando && temBoleto && (
						<>
							<button type="button" className="totem-botao totem-botao-primario" disabled={carregando !== null} onClick={() => onImprimir(fatura)}>
								<span className="material-icons" aria-hidden="true">print</span>
								{carregando === 'pdf' ? 'Gerando...' : 'Imprimir boleto'}
							</button>
							{temPix && (
								<button type="button" className="totem-botao totem-botao-claro" disabled={carregando !== null} onClick={() => onPix(fatura)}>
									<span className="material-icons" aria-hidden="true">pix</span>
									{carregando === 'pix' ? 'Gerando...' : 'Pagar com PIX'}
								</button>
							)}
							<button type="button" className="totem-botao totem-botao-claro" disabled={carregando !== null} onClick={() => onLinhaDigitavel(fatura)}>
								<span className="material-icons" aria-hidden="true">qr_code_scanner</span>
								{carregando === 'linha' ? 'Buscando...' : 'Código do boleto'}
							</button>
						</>
					)}
					{!processando && !temBoleto && <span className="totem-fatura-aviso">Boleto ainda não disponível. Procure o atendimento.</span>}
				</div>
			)}
		</div>
	);
}
